const useCaseConverter = () => {
  return {
    ignoreParams: true,
    caseOptions: {
      stripRegexp: /[^A-Z0-9-]+/gi
    },
    caseFunctions: {
      camel: (input: string) => {
        return (input.charAt(0).toLowerCase() + input.slice(1)).replace(
          /[_](.)/g,
          (match, group1) => group1.toUpperCase()
        )
      }
    }
  }
}

export default useCaseConverter
